module.exports = __webpack_public_path__ + "img/logo.647c6f9d.svg";